import { render, staticRenderFns } from "./WeekdayTable.vue?vue&type=template&id=67152906&scoped=true&"
import script from "./WeekdayTable.vue?vue&type=script&lang=ts&"
export * from "./WeekdayTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67152906",
  null
  
)

export default component.exports